import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var Star25SVG = function Star25SVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M28.28,11.46,21,10.12l-3.52-6.9C17.09,2.41,16.55,2,16,2s-1.09.41-1.51,1.22L11,10.12,3.72,11.46c-1.8.34-2.26,1.71-1,3.06l5.16,5.6-1,7.78c-.17,1.32.39,2.1,1.34,2.1a2.68,2.68,0,0,0,1.19-.33L16,26.3l6.65,3.37a2.68,2.68,0,0,0,1.19.33c.95,0,1.51-.78,1.34-2.1l-1-7.78,5.16-5.6C30.54,13.17,30.08,11.8,28.28,11.46Zm-6.26,8,1.1,8.21L16,24.05,8.88,27.66,10,19.45l2.34-7.55L16,4.69l3.69,7.21,7.93,1.48Z"
  }));
};
Star25SVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(Star25SVG);